// eslint-disable-next-line no-unused-vars
import { debug } from '@/config/config.js';


function base64Encode(data) {
    // 首先将字符串转换为 UTF-8 格式，然后用 btoa() 进行 Base64 编码
    return btoa(unescape(encodeURIComponent(data)));
}

// Base64 解码函数
function base64Decode(data) {
    // 使用 atob() 解码 Base64 字符串，然后将结果转换为 UTF-8 格式
    return decodeURIComponent(escape(atob(data)));
}

function getRandomChar() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return chars.charAt(Math.floor(Math.random() * chars.length));
}

function encrypt(data) {
    // Step 1: Base64 编码
    let encodedData = base64Encode(data);

    // Step 2: 如果是单数长度，则在中间位置随机补充一个字符
    if (encodedData.length % 2 !== 0) {
        const randomChar = getRandomChar();
        const midIndex = Math.floor(encodedData.length / 2);
        encodedData = encodedData.slice(0, midIndex) + randomChar + encodedData.slice(midIndex);
    }

    // Step 3: 选择 2% - 98% 区间的字符进行倒置
    const startIndex = Math.floor(encodedData.length * 0.06);
    const endIndex = Math.floor(encodedData.length * 0.88);
    const partToReverse = encodedData.slice(startIndex, endIndex);
    const reversedPart = partToReverse.split('').reverse().join('');

    // Step 4: 拼接加密后的结果
    return encodedData.slice(0, startIndex) + reversedPart + encodedData.slice(endIndex);
}

// 解密函数
function decrypt(encryptedData) {
    // Step 1: 找到加密时倒置的部分，恢复倒置的部分
    const startIndex = Math.floor(encryptedData.length * 0.06);
    const endIndex = Math.floor(encryptedData.length * 0.88);
    const reversedPart = encryptedData.slice(startIndex, endIndex).split('').reverse().join('');

    // Step 2: 恢复倒置的部分
    let decryptedData = encryptedData.slice(0, startIndex) + reversedPart + encryptedData.slice(endIndex);

    // Step 3: 去除补充的字符
    const midIndex = Math.floor(decryptedData.length / 2);
    if (decryptedData.length % 2 !== 0) {
        decryptedData = decryptedData.slice(0, midIndex) + decryptedData.slice(midIndex + 1);
    }

    // Step 4: Base64 解码
    return base64Decode(decryptedData);
}

function handleEncryptData(data, isDebug=false) {
    if(isDebug) {
        return JSON.stringify(data)
    } else {
        return encrypt(JSON.stringify(data))
    }
}

function handleDecryptData(data, isDebug=false) {
    if(isDebug) {
        return JSON.parse(data)
    } else {
        return JSON.parse(decrypt(data))
    }
}

export { handleEncryptData, handleDecryptData };
